
import React from 'react';
import { Form, Input, Button, Row, Col, Icon } from 'antd';

const labelStyle = {
  fontWeight: "800",
  fontSize: "16px",
  width: '100%',
  textAlign:'left',
  whiteSpace: 'normal',
  display:'inline-flex'
};

class AutorizedPersonsForm extends React.Component {
  render() {
    const { authorized_persons, onAuthorizedDetailChange, onAddAuthorize, onDeleteAuthorize } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        {authorized_persons.map((person, index) => (
          <Form.Item
          label={ index === 0 ?
            <span style={labelStyle}>
              Name and Title of the persons authorized to act on your behalf
            </span> : ''
          }
        >

        {getFieldDecorator("authorized_persons", {
                  initialValue: authorized_persons,
                  rules: [{ required: false, message: "Required" }],
                })(
          <Row key={index} gutter={16}>
            <Col xs={24} sm={24} md={10}>
              <Form.Item>
                <Input
                  size="large"
                  placeholder="Name"
                  value={person.autorizedPersonName || ''}
                  onChange={e => onAuthorizedDetailChange(index, 'autorizedPersonName', e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10}>
               <Form.Item>
                 <Input size="large" placeholder="Title" 
                  value={person.autorizedPersonTitle || ''}
                  onChange={e => onAuthorizedDetailChange(index, 'autorizedPersonTitle', e.target.value)}
                 />
               </Form.Item>
             </Col>
          
            {/* Other input fields */}
            <Col xs={24} sm={24} md={4}>
              {index === authorized_persons.length - 1 ? (
                <Button type="dashed" onClick={onAddAuthorize} style={{ width: '100%' }}>
                  <Icon type="plus" />
                </Button>
              ) : (
                <Button type="dashed" onClick={() => onDeleteAuthorize(index)} style={{ width: '100%' }}>
                  <Icon type="minus" />
                </Button>
              )}
            </Col>
          </Row>
        )}
        </Form.Item>
        ))}
      </Form>
    );
  }
}

export default AutorizedPersonsForm;
